//react imports
import React, { useState, useEffect } from "react";

//material ui imports
import {
  lighten,
  makeStyles,
  Grid,
  Tooltip,
  Menu,
  Table,
  Select,
  MenuItem,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  InputAdornment,
  FormControl,
  InputLabel,
  Typography,
} from "@material-ui/core";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import Icon from "@material-ui/core/Icon";

//other modules imports
import PropTypes from "prop-types";
import swal from "@sweetalert/with-react";
import moment from "moment";
import { useHistory, useParams } from "react-router-dom";


//global imports
import Global from "../../Global";
import Colors from "../../Global/colors";
import Spinner from "../../Global/Spinner2";
import DarkButton from "../../Global/DarkButton";
import LightButton from "../../Global/LightButton";
import NoRecords from "../../Global/NoRecords";
import MoreOptionDailog from "../templateTools/MoreOptionDailog";

//helper imports
import refreshTokens from "../../Global/refresh_token";

//styles and images imports
import "./activity.css";
import { useSelector } from "react-redux";

//translation imports
import { useTranslation } from "react-i18next";

//preparing styles
const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  container: {
    maxHeight: "65vh",
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
  },

  textField: {
    backgroundColor: Colors.globalColor5,
    border: "none",
    borderRadius: 5,
  },
  resize: {
    padding: "12px",
    fontSize: "12px",
  },
  password: {
    padding: "2px",
  },
  switchBase: {
    color: "#818181",
    padding: "1px",
    "&$checked": {
      "& + $track": {
        backgroundColor: "#043077",
      },
    },
  },
  thumb: {
    color: "white",
    width: "20px",
    height: "20px",
    margin: "1px",
  },
  track: {
    borderRadius: "20px",
    width: "200px",
    backgroundColor: "#818181",
    opacity: "1 !important",
    "&:after, &:before": {
      color: "white",
      fontSize: "11px",
    },
    "&:after": {
      content: "'activate'",
      left: "7px",
    },
    "&:before": {
      content: "'deactivate'",
      right: "8px",
    },
  },
  checked: {
    color: "#043077 !important",
    transform: "translateX(50px) !important",
  },
}));

//main function
function ActivityLog() {
  const { organization_id, user_id } = useParams();
  const {t} = useTranslation();
  const history = useHistory();
  const [toDate, setToDate] = useState(undefined);
  const [fromDate, setFromDate] = useState(undefined);
  const [selectedFeature, setSelectedFeature] = useState("All");
  const [tempLoader, setTempLoader] = useState(false);
  const classes = useStyles();
  const [companies, setCompanies] = useState([]);
  const [users, setUsers] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState("");
  const [selectedUser, setSelectedUser] = useState("all");
  let language = useSelector((state) => state.languageReducer.language);
  let currentCompany = useSelector(state => state.companyReducer.company);
  const [selected, setSelected] = useState([]);
  const [rows, setRows] = useState([]);
  const headCells = [
    {
      id: "dateTime",
      numeric: false,
      disablePadding: false,
      label: <>{t("Date & Time")}</>,
      borderLeft: false,
      borderRight: true,
    },
    {
      id: "company",
      numeric: true,
      disablePadding: false,
      label: <>{t("Company")}</>,
      borderLeft: false,
      borderRight: true,
    },
    {
      id: "activityType",
      numeric: true,
      disablePadding: false,
      label: <>{t("Activity Type")}</>,
      borderLeft: false,
      borderRight: true,
    },
    {
      id: "type",
      numeric: true,
      disablePadding: false,
      label: <>{t("System Feature")}</>,
      borderLeft: false,
      borderRight: true,
    },
    {
      id: "description",
      numeric: true,
      disablePadding: false,
      label: <>{t("Description")}</>,
      borderLeft: false,
      borderRight: false,
    },
  ];

  const startDate = moment(toDate).subtract(1, "months");
  const endDate = moment(fromDate).add(1, "months");

//set from date
  const handleFromDateChange = (date) => {
    setFromDate(date);
    //set to date one month after from date if difference is more than one month
    if (moment(date).diff(moment(toDate), "months") < 0) {
      setToDate(moment(date).add(1, "months"));
    }

  }

  //handle to Date
  const handleToDateChange = (date) => {
    setToDate(date);
    //set from date one month before to date if difference is more than one month
    if (moment(date).diff(moment(fromDate), "months") > 1) {
      setFromDate(moment(date).subtract(1, "months"));
    }
  }



  //on mount useEffect
  useEffect(() => {
    getCompaniesAndUsers();
  }, []);


  function getCompaniesAndUsers() {
    // setTempLoader(true);
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data?.token;
    let params = {
      organization_id:data.organization_id,
    };
    // console.log(data.user_id);
    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");

    fetch(Global + "/ActivityLog/get_data_for_activity_log?" + query, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    })
      .then((responseJson) => responseJson.json())
      .then(async (response) => {
        console.log(response, "response");
        if (response.msg === "success") {
          await setCompanies(response.companies);
          await setSelectedCompany(response.companies[0].id);
          await setUsers(response.companies[0].Users);
          await setSelectedUser(response.companies[0].Users[0].id);



          if (
            response.companies.length > 0 
          ) {
            await getActivityLog(
              response.companies[0].id,
              response.companies[0].Users.length > 0 ? response.companies[0].Users[0].id : undefined
            );
          }
        } else if (
          response.error === "jwt expired" ||
          response.error === "invalid token" ||
          response.error === "invalid signature" ||
          response.error === "Unexpected token"
        ) {
          let status = await refreshTokens();
          console.log(status);
          if (status) {
            getCompaniesAndUsers();
          }
        }
      })
      .catch((error) => console.log(error.message));
  }

  function getActivityLog(companyId, userId) {
    setTempLoader(true);

    //if selected company is empty return with swal
    if (companyId === "") {
      setTempLoader(false);
      swal(t("warning"), t("Please select company"), "warning");
      return;
    }



    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data?.token;
    let params = {
      organization_id:currentCompany.organization_id,
      company_id: companyId,
      user_id: userId,
      to_date: toDate,
      from_date: fromDate,
      type: selectedFeature === "All" ? undefined : selectedFeature,
    };
    console.log("params", token);
    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");

    fetch(Global + "/ActivityLog/activity_log?" + query, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    })
      .then((responseJson) => responseJson.json())
      .then(async (response) => {
        console.log(response, "response2");
        if (response.msg === "success") {
          setTempLoader(false);
          setRows(response.activity_log);
        } else if (
          response.error === "jwt expired" ||
          response.error === "invalid token" ||
          response.error === "invalid signature" ||
          response.error === "Unexpected token"
        ) {
          let status = await refreshTokens();
          console.log(status);
          if (status) {
            getCompaniesAndUsers();
          }
        }else{
          swal(t("Error"), response.error, "error");
        }
      })
      .catch((error) => console.log(error.message));
  }

  function changeCompany(companyId) {
    let users = companies.filter((item) => item.id === companyId)[0].Users;
    if (users.length > 0) {
      setSelectedCompany(companyId);
      setUsers(users);
      setSelectedUser(users[0].id);
    } else {
      setSelectedCompany(companyId);
      setUsers([]);
      setSelectedUser("all");
    }

  }

  function changeUser(userId) {
    setSelectedUser(userId);
  }

  //handler functions ===>
  const handleScroll = (e) => {
    const bottom =
      e.target.scrollHeight - Math.ceil(e.target.scrollTop) ===
      e.target.clientHeight;
    const top = e.target.scrollTop == 0;
    if (bottom) {
      return true;
    }
  };

  //Table Head Component
  function EnhancedTableHead(props) {
    const { classes, order, orderBy, onRequestSort } = props;

    return (
      <TableHead>
        <TableRow>
          {headCells.map((headCell, index) => (
            <TableCell
              style={{
                borderTop: "1px solid #dadada",
                borderLeft: headCell.borderLeft ? "1px solid #dadada" : "none",
                borderRight: headCell.borderRight
                  ? "1px solid #dadada"
                  : "none",
                padding: "7px",
                fontWeight: "bold",
                color: Colors.globalColor8,
                textAlign: language === "ar" && "right",
                textTransform: "capitalize",
                backgroundColor: "#f2f2f2",
              }}
              key={headCell.id}
              align={"left"}
              padding={headCell.disablePadding ? "none" : "default"}
              sortDirection={orderBy === headCell.id ? order : false}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <span className={classes.visuallyHidden}>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </span>
              ) : null}
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
    );
  }

  EnhancedTableHead.propTypes = {
    classes: PropTypes.object.isRequired,
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.oneOf(["asc", "desc"]).isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired,
  };

  //return from main function
  return <>
    <div style={{ padding: "20px", overflow: "auto", backgroundColor: "#eaf7fe" }}>
      <div className="scrollHidden shadow" style={{ backgroundColor: "white", padding: "20px", borderRadius: "5px", marginTop: "0px", overflowY: "hidden", width: "100%", height: "84vh" }}>
        <Grid container justifyContent="center" alignItems="center">
          <Grid spacing={1} container justifyContent="center" alignItems="center">
            <Grid item xs={12} md={2}>
              <FormControl fullWidth size="small" variant="outlined">
                <InputLabel id="demo-simple-select-outlined-label">
                  {t("Select Company")}
                </InputLabel>
                <Select label="Select Company" fullWidth labelId="demo-simple-select-outlined-label" id="demo-simple-select-outlined" value={selectedCompany} onChange={(e) => changeCompany(e.target.value)}>
                  {companies.length > 0 ? companies.map((company) => (
                    <MenuItem key={company.id} value={company.id}>
                      {company.company_name}
                    </MenuItem>
                  )) : <MenuItem value="">No Company Found</MenuItem>}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={2}>
              <FormControl fullWidth size="small" variant="outlined">
                <InputLabel id="demo-simple-select-outlined-label">
                  {t("Select User")}
                </InputLabel>
                <Select label="Select User" fullWidth labelId="demo-simple-select-outlined-label" id="demo-simple-select-outlined" value={selectedUser} onChange={(e) => changeUser(e.target.value)}>
                  {users.map((user) => (
                     <MenuItem key={user.id} value={user.id}>
                     {user.first_name} {user.last_name}
                   </MenuItem>
                 ))}
                  <MenuItem value="all" key={"all"}>
                     All
                   </MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={2}>
              <MuiPickersUtilsProvider utils={DateFnsUtils} classes={{ input: classes.input }}>
                <KeyboardDatePicker variant="inline"  className="datePick"
                  disableFuture inputVariant="outlined" label={t("From Date")} disableToolbar size="small" format="MM/dd/yyyy" id="date-picker-inline" 
                  value={fromDate || new Date()} InputProps={{ disableUnderline: true }} onChange={(e) => handleFromDateChange(e)} KeyboardButtonProps={{ "aria-label": "change date" }} keyboardIcon={<Icon style={{ color: Colors.globalColor8, fontSize: 20, alignSelf: "center", height: 30 }}>
                    date_range
                  </Icon>} fullWidth />
              </MuiPickersUtilsProvider>
            </Grid>
            <Grid item xs={12} md={2}>
              <MuiPickersUtilsProvider utils={DateFnsUtils} classes={{ input: classes.input }}>
                <KeyboardDatePicker className="datePick" variant="inline" disableFuture  inputVariant="outlined" label={t("To Date")} disableToolbar size="small" format="MM/dd/yyyy" id="date-picker-inline" 
                  value={toDate || new Date()} InputProps={{ disableUnderline: true }} onChange={(e) => handleToDateChange(e)} KeyboardButtonProps={{ "aria-label": "change date" }} keyboardIcon={<Icon style={{ color: Colors.globalColor8, fontSize: 20, alignSelf: "center", height: 30 }}>
                    date_range
                  </Icon>} fullWidth />
              </MuiPickersUtilsProvider>
            </Grid>
            <Grid item xs={12} md={2}>
              <FormControl fullWidth size="small" variant="outlined">
                <InputLabel id="demo-simple-select-outlined-label">
                  {t("Select Feature")}
                </InputLabel>
                <Select label="Select Feature" fullWidth labelId="demo-simple-select-outlined-label" id="demo-simple-select-outlined" defaultValue={selectedFeature} onChange={(e) => setSelectedFeature(e.target.value)}>
                  {["All","Template", "Schedule", "Inspection", "Notification", "Site", "Area", "Region", "Company", "Hierarchy", "User", "Action","Package","Response"].map(
                    (item, index) => (
                      <MenuItem key={index} value={item}>
                        {item}
                      </MenuItem>
                    )
                  )}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={2}>
              <DarkButton
                onClick={() =>
                  getActivityLog(selectedCompany, selectedUser)
                }
              >
                {t("Generate Log")}
              </DarkButton>
            </Grid>
          </Grid>
          <hr />
          <div style={{ width: "100%" }}>
            <div className="scrollbarShow2" style={{ overflow: "hidden", width: "100%" }}>
              {tempLoader && <div style={{ display: "flex", justifyContent: "center", alignItems: "center", width: "100%", textAlign: "center", padding: 20, height: "60vh" }}>
                <Spinner />
              </div>}
              {!tempLoader && <Grid container justifyContent="center" spacing={1} style={{ padding: "20px 5px 10px", height: "72vh" }}>
                {!tempLoader && rows?.length == 0 && <div style={{ padding: "20px", width: "100%", display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
                  <NoRecords />
                </div>}

                {!tempLoader && rows?.length !== 0 && <>
                  <TableContainer className={classes.container} id="TemplateScroll" onScroll={(e) => handleScroll(e)}>
                    <Table className="scrollHidden templateTable" stickyHeader aria-label="sticky table" style={{ borderLeft: "1px solid #dadada", borderRight: "1px solid #dadada" }}>
                      <EnhancedTableHead classes={classes} rowCount={rows?.length} />
                      <TableBody classname="scrollHidden">
                        {rows.map((row, index) => {
                          console.log("ROW", row);
                          return <TableRow hover role="checkbox" tabIndex={-1} key={row.id} className="testingtable new-hover">
                            <TableCell style={{ padding: "3px 10px", textAlign: "center", borderRight: "1px solid #dadada" }}>
                              <p style={{ margin: "3px  0px" }}>
                                {moment(new Date(row?.createdAt)).format("DD/MM/YYYY")}
                              </p>
                            </TableCell>
                            <TableCell style={{ padding: "3px 10px", textAlign: "center", borderRight: "1px solid #dadada" }}>
                              <p style={{ margin: "3px  0px" }}>
                                {row.company_name}
                              </p>
                            </TableCell>
                            <TableCell style={{ padding: "3px 10px", textAlign: "center", borderRight: "1px solid #dadada" }}>
                              <p style={{ margin: "3px  0px" }}>
                                {row?.action_performed}
                              </p>
                            </TableCell>
                            <TableCell style={{ padding: "3px 10px", textAlign: "center", borderRight: "1px solid #dadada" }}>
                              <p style={{ margin: "3px  0px" }}>
                                {row?.type}
                              </p>
                            </TableCell>
                            <TableCell style={{ padding: "3px 10px", textAlign: language=="ar" ? "right" : "left", borderRight: "1px solid #dadada", maxWidth: "500px" }}>
                              <p style={{ margin: "3px  0px" }}>
                                {row?.description}
                              </p>
                            </TableCell>
                          </TableRow>;
                        })}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </>}
              </Grid>}
            </div>
          </div>
        </Grid>
      </div>
    </div>
  </>;
}

export default ActivityLog;
